import React, { useEffect, useState } from 'react'
import Header from '../../component/Header';


export default function OurCompany(props) {

    const [cardShow, setCardShow] = useState(0);
    const [isShow, setIsShow] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <>
            <Header />
            <section className='banner-section-about top bottom-1 p-l-r'>
                <div className='about-banner-content'>
                    {/* <img src={require('../../assets/images/frame1.png')} /> */}
                    <h1 className='about-page-heading'>
                        We’re a Energetic & optimistic bunch of people, united by one goal –<br /> Holistic Wellness.
                    </h1>
                </div>
            </section>
            <section className='bottom p-l-r about-2-section'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='left-section'>
                                <ul className='left-list-box'>
                                    <li>
                                        <div className='vission-mission'>
                                            <img src={require('../../assets/images/icon/mission.png')} alt='mission' />
                                            <h3>Our Mission</h3>
                                            <p className='paragraph'>
                                                To provide individuals with the tools to lead a healthier, more balanced life through mindfulness, Ayurveda, and holistic wellness practices. We are passionate about offering a safe space for reflection, personal growth, and mindful living.
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className='vission-mission'>
                                            <img src={require('../../assets/images/icon/vision.png')} alt='vision' />
                                            <h3>Our Vision</h3>
                                            <p className='paragraph'>
                                                To Empower individuals on their journey toward holistic living, personal growth, and emotional well-being. Give people a safe space where all their concerns are sorted in one Space. Exploring mindfulness, self-discovery, and wellness practices. Synchronizing ancient Ayurvedic wisdom with modern health practices.
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                                <div className='right-section'>
                                    <div className='row'>
                                        <div className='col-lg-2 col-6'>
                                            <ul>
                                                <li><img src={require('../../assets/images/balanced-life.jpg')} /></li>
                                            </ul>
                                        </div>
                                        <div className='col-lg-2 col-6'>
                                            <ul>
                                                <li><img src={require('../../assets/images/meditation.jpg')} /></li>
                                            </ul>
                                        </div>
                                        <div className='col-lg-2 col-6'>
                                            <ul>
                                                <li><img src={require('../../assets/images/ayurveda.jpg')} /></li>
                                            </ul>
                                        </div>
                                        <div className='col-lg-2 col-6'>
                                            <ul>
                                                <li><img src={require('../../assets/images/lifestyle.jpg')} /></li>
                                            </ul>
                                        </div>
                                        <div className='col-lg-2 col-6'>
                                            <ul>
                                                <li><img src={require('../../assets/images/relationship.jpg')} /></li>
                                            </ul>
                                        </div>
                                        <div className='col-lg-2 col-6'>
                                            <ul>
                                                <li><img src={require('../../assets/images/self-discovery.jpg')} /></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section className='our-founder bottom top p-l-r'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-5'>
                            <div className='right-section'>
                                <img src={require('../../assets/images/founder.jpg')} alt='founder' />
                            </div>
                        </div>
                        <div className='col-lg-7'>
                            <div className='left-section'>
                                <div className='ab-child-box'>
                                    <p className='paragraph'>
                                        If You know Ashmita, Our Founder, you would have heard her say that , “well-being isn’t a luxury — it’s a daily choice.” So being the fearless optimist she is, this mission is something that she believes in and has got it to life.
                                    </p>
                                    <p className='paragraph mb-0'>
                                        Wellness isn’t about grand gestures; it’s about small, consistent actions that lead to lasting change.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='space-div'>

            </section>
            <section className='our-manifesto top bottom p-l-r'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-12'>
                            <div class="mental-health-content">
                                <h3 class="heading2 text_gradient">
                                    Our Manifesto
                                </h3>
                            </div>
                        </div>
                        <div className='col-lg-4 box_1_ p-0'>
                            <div className='manifesto-list'>
                                <h4>Wellbeing isn’t a universal formula — </h4>
                                <p>We believe it should be personalized to suit each individual’s unique needs.</p>
                            </div>
                        </div>
                        <div className='col-lg-4 box_2_ p-0'>
                            <div className='manifesto-list'>
                                <h4>Wellbeing shouldn’t be a luxury </h4>
                                <p>Expert guidance should be accessible to everyone, not just the top 1%.</p>
                            </div>
                        </div>
                        <div className='col-lg-4 box_3_ p-0'>
                            <div className='manifesto-list'>
                                <h4>Wellbeing is not limited to a single aspect — </h4>
                                <p>We believe it encompasses 6 interconnected and overlapping areas.</p>
                            </div>
                        </div>
                        <div className='col-12'>
                            <blockquote>We believe that even small changes can pave the way to a healthier and more fulfilling life.</blockquote>
                        </div>

                    </div>
                </div>
            </section>
            <section className='story-section bottom p-l-r'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-6'>
                            <div className='left-section'>
                                <div class="mental-health-content">
                                    <h3 class="heading2 text_gradient">
                                        The journey behind The Beyond Lifestyle is a powerful testament to overcoming challenges and rising above adversity.
                                    </h3>
                                    <h4>And The Beyond Lifestyle Was Born.</h4>
                                </div>
                            </div>
                        </div>
                        {/* <div className='col-lg-4'>
                            <div className='circle-box-story'>
                                <div className='circle-box-story-1'>
                                    <h5>The Beyond Lifestyle Was Born.</h5>
                                </div>
                            </div>
                        </div> */}
                        <div className='col-lg-6'>
                            {/* <div className='middle-section-about'>
                                <img src={require('../../assets/images/slim-beautiful-woman-doing-sports-morning-park-doing-yoga.jpg')} />
                            </div> */}
                            <div className='right-section right-section-new-1'>
                                <p className='paragraph'>
                                    Our Founder Ashmita, curated this application based on her own wellness journey after giving birth during the pandemic. Like so many others, she struggled to find balance between work, raising a child, and taking care of herself. There were days when she felt overwhelmed, lost, and disconnected, and realized there wasn’t a single app out there that could support both her mental and physical health in a meaningful way. So, she decided to build one.
                                </p>
                                <p className='paragraph'>In today’s fast-paced, stressful world, we all need a moment to pause, reflect, and breathe. She wanted to create an app that helps people do just that—an accessible space where you can take time for yourself, find peace, and grow. It’s not just about fitness or mindfulness; it’s about nurturing your whole self. Synchronizing ancient Ayurvedic wisdom with modern health practices, we help individuals lead healthier, happier lives.</p>
                                <p className='paragraph'>This app was built from her heart, driven by a deep passion to help others reconnect with their inner selves and find harmony in both mind and body. Her ultimate hope is to guide people towards healthier, more balanced lives. Because you deserve it. We all do.</p>

                            </div>
                        </div>
                        {/* <div className='col-lg-6'>

                        </div> */}
                    </div>
                </div>
            </section>
            <section className='our-core-principles top bottom p-l-r'>
                <div className='container-fluid'>
                    <div className='row justify-content-center'>
                        <div className='col-lg-12'>
                            <div class="mental-health-content">
                                <h3 class="heading2 text_gradient_2">
                                    Our Core Principles
                                </h3>

                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6'>
                            <div className='principle-card'>
                                {
                                    cardShow == 1 ? <button className='active' onClick={() => setCardShow(0)}>
                                        <i class="fa-solid fa-minus"></i>
                                    </button>
                                        :
                                        <button onClick={() => setCardShow(1)}>
                                            <i class="fa-solid fa-plus"></i>
                                        </button>
                                }

                                <h4>Ayurvedic<br/> Wisdom</h4>
                                <div className={cardShow == 1 ? 'principle_content active' : 'principle_content'}>
                                    <p className='paragraph'>
                                        We bring ancient wisdom to modern living — helping you restore balance, harmony, and holistic wellbeing from the inside out.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6'>
                            <div className='principle-card'>
                                {
                                    cardShow == 2 ? <button className='active' onClick={() => setCardShow(0)}>
                                        <i class="fa-solid fa-minus"></i>
                                    </button>
                                        :
                                        <button onClick={() => setCardShow(2)}>
                                            <i class="fa-solid fa-plus"></i>
                                        </button>
                                }
                                <h4>Holistic<br/> Wellbeing</h4>
                                <div className={cardShow == 2 ? 'principle_content active' : 'principle_content'}>
                                    <p className='paragraph'>
                                        Wellness isn’t just physical — it’s emotional, mental, and spiritual. We would support your journey to whole-person wellbeing, one mindful step at a time.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6'>
                            <div className='principle-card'>
                                {
                                    cardShow == 3 ? <button className='active' onClick={() => setCardShow(0)}>
                                        <i class="fa-solid fa-minus"></i>
                                    </button>
                                        :
                                        <button onClick={() => setCardShow(3)}>
                                            <i class="fa-solid fa-plus"></i>
                                        </button>
                                }
                                <h4>Empowering<br/> Individual</h4>
                                <div className={cardShow == 3 ? 'principle_content active' : 'principle_content'}>
                                    <p className='paragraph'>
                                        Make Yourself In-charge of your wellbeing. We’re here to help you reconnect with your inner power and make choices that support your unique path to health and happiness.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6'>
                            <div className='principle-card'>
                                {
                                    cardShow == 4 ? <button className='active' onClick={() => setCardShow(0)}>
                                        <i class="fa-solid fa-minus"></i>
                                    </button>
                                        :
                                        <button onClick={() => setCardShow(4)}>
                                            <i class="fa-solid fa-plus"></i>
                                        </button>
                                }
                                <h4>Mindfulness</h4>
                                <div className={cardShow == 4 ? 'principle_content active' : 'principle_content'}>
                                    <p className='paragraph'>
                                        Wellbeing begins with awareness. Through mindfulness, we guide you to tune into your thoughts, emotions, and body — cultivating clarity, calm, and conscious living.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6'>
                            <div className='principle-card'>
                                {
                                    cardShow == 5 ? <button className='active' onClick={() => setCardShow(0)}>
                                        <i class="fa-solid fa-minus"></i>
                                    </button>
                                        :
                                        <button onClick={() => setCardShow(5)}>
                                            <i class="fa-solid fa-plus"></i>
                                        </button>
                                }
                                <h4>Consistency</h4>
                                <div className={cardShow == 5 ? 'principle_content active' : 'principle_content'}>
                                    <p className='paragraph'>
                                        True transformation comes from what you do regularly, not occasionally. We’re here to help you show up for yourself — one mindful habit at a time.
                                    </p>
                                </div>
                            </div>
                        </div>
                        {/* <div className='col-lg-4 col-md-6'>
                            <div className='principle-list'>
                                <div className='left-section'>
                                    <h4>Ayurvedic Wisdom</h4>
                                    <p className='paragraph'>
                                        We bring ancient wisdom to modern living — helping you restore balance, harmony, and holistic wellbeing from the inside out.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6'>
                            <div className='principle-list after_remove1'>
                                <div className='left-section'>
                                    <h4>Holistic Wellbeing</h4>
                                    <p className='paragraph'>
                                        Wellness isn’t just physical — it’s emotional, mental, and spiritual. We would support your journey to whole-person wellbeing, one mindful step at a time.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6'>
                            <div className='principle-list after_remove2'>
                                <div className='left-section'>
                                    <h4>Empowering Individual</h4>
                                    <p className='paragraph'>
                                        Make Yourself In-charge of your wellbeing. We’re here to help you reconnect with your inner power and make choices that support your unique path to health and happiness.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6'>
                            <div className='principle-list after_remove3'>
                                <div className='left-section'>
                                    <h4>Mindfulness</h4>
                                    <p className='paragraph'>
                                        Wellbeing begins with awareness. Through mindfulness, we guide you to tune into your thoughts, emotions, and body — cultivating clarity, calm, and conscious living.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6'>
                            <div className='principle-list after_remove4'>
                                <div className='left-section'>
                                    <h4>Consistency</h4>
                                    <p className='paragraph'>
                                        True transformation comes from what you do regularly, not occasionally. We’re here to help you show up for yourself — one mindful habit at a time.
                                    </p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section >
        </>
    )
}
